export const LOAD_LEAVE_POLICIES = "LOAD_LEAVE_POLICIES";
export const EDIT_LEAVE_POLICY = "EDIT_LEAVE_POLICY";
